module.exports = __webpack_public_path__ + "static/img/1112_phase_function_Paper_Points.267a729.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/raw_data/images/1112_phase_function_Paper_Points.png
// module id = jVGf
// module chunks = 0